import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    permanentDeletionTooltip: (duration: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            permanentDeletionTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (duration: string) => __intl__.intl().formatMessage({ id: "PermanentDeletionLabel.permanentDeletionTooltip?c=276nyi8xd84rr", defaultMessage: "This asset will be permanently deleted in {duration}" }, { duration: duration }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
